module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "before-you-begin"
    }
  }, [_c('h1', [_vm._v("Before You Begin")]), _vm._v(" "), _c('p', [_vm._v("There are all sorts of things to think about before you even encounter pupils. I recognise that this might be frustrating if you want to get stuck into the practicalities of dealing with pupils but, and it’s an important ‘but’, getting a few things straight before the first pupil comes into your classroom is really important. They are all a part of practising the art of successful classroom management and they do have an impact on your day-to-day teaching.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2cea7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 87
// module chunks = 0